'use strict';

var base = require('./base');

module.exports = {
    init: function () {
        var $body = $('body');
        var lastAddedAsRegularDelivery = false;
        var lastAddedHasRegularDeliveryOption = false;
        var lastAddedRegularDeliveryDiscountPercentage = null;
        var lastAddedRegularDeliveryFrequency = null;

        function isRDSelected($container) {
            if (!$container || !$container.length) return false;
            var selectedValueId = $container.find('.js-purchaseType:checked').data('value-id');
            var defaultValueId = $container.data('default-value-id');
            return selectedValueId !== defaultValueId;
        }

        function appendRDParam(url, $container) {
            if (!url) return url;
            url = url.replace(/[?&]showRDPrice=(true|false)/g, '');
            var separator = url.indexOf('?') === -1 ? '?' : '&';
            return url + separator + 'showRDPrice=' + isRDSelected($container);
        }

        function findRDContainer($element) {
            var $productContainer = $element.closest('.js-productDetail');
            if (!$productContainer.length) {
                $productContainer = $element.closest('.quick-view-dialog').find('.js-productDetail');
            }
            if (!$productContainer.length) {
                $productContainer = $element.closest('.set-item');
            }
            if (!$productContainer.length) {
                $productContainer = $element.closest('.js-prod-tile');
            }
            if (!$productContainer.length) {
                $productContainer = $element.closest('.product');
            }

            return $productContainer.find('.js-regularDelivery');
        }

        function getRegularDeliverySelectionData($element) {
            var selection = {
                isRegularDelivery: false,
                frequency: null,
                hasRegularDeliveryOption: false,
                discountPercentage: null
            };

            var $rdContainer = findRDContainer($element);
            if ($rdContainer.length) {
                var selectedValueId = $rdContainer.find('.js-purchaseType:checked').data('value-id');
                var defaultValueId = $rdContainer.data('default-value-id');
                var $rdSelect = $rdContainer.find('.options-select').first();
                var $rdOptions = $rdSelect.find('option').filter(function () {
                    return String($(this).data('value-id')) !== String(defaultValueId) && !$(this).is(':disabled');
                });

                selection.hasRegularDeliveryOption = $rdOptions.length > 0;

                selection.isRegularDelivery = !!(selectedValueId && defaultValueId && selectedValueId !== defaultValueId);

                if (selection.isRegularDelivery) {
                    var $frequencyWrapper = $rdContainer.find('.js-rdFrequencyWrapper').not('.d-none');
                    var $frequencySelect = $frequencyWrapper.find('select.js-rdFrequency').first();

                    if (!$frequencySelect.length) {
                        $frequencySelect = $rdContainer.find('select.js-rdFrequency').first();
                    }
                    if (!$frequencySelect.length) {
                        $frequencySelect = $rdContainer.find('#rdFrequency').first();
                    }

                    selection.frequency = $frequencySelect.val() || null;
                }

                return selection;
            }

            var $productContainer = $element.closest('.js-prod-tile');
            if (!$productContainer.length) {
                $productContainer = $element.closest('.product').find('.js-prod-tile');
            }

            var $rdOption = $productContainer.find('.product-option[data-option-id="regularDeliveryOption"]').first();
            if ($rdOption.length) {
                var $select = $rdOption.find('.options-select').first();
                var selectedId = $select.find('option:selected').data('value-id');
                var firstId = $select.find('option').first().data('value-id');
                var $tileRdOptions = $select.find('option').not(':first').filter(function () {
                    return !$(this).is(':disabled');
                });

                selection.hasRegularDeliveryOption = $tileRdOptions.length > 0;

                selection.isRegularDelivery = !!(selectedId && firstId && String(selectedId) !== String(firstId));

                if (selection.isRegularDelivery) {
                    var $tileFrequency = $rdOption.find('select.js-rdFrequency').first();
                    if (!$tileFrequency.length) {
                        $tileFrequency = $rdOption.find('#rdFrequency').first();
                    }
                    selection.frequency = $tileFrequency.val() || null;
                }

                return selection;
            }

            // Fallback to data attributes (for tile quick-add buttons)
            selection.hasRegularDeliveryOption = $element.attr('data-has-regular-delivery-option') === 'true';
            selection.isRegularDelivery = $element.attr('data-is-regular-delivery') === 'true';
            selection.frequency = $element.attr('data-regular-delivery-frequency') || null;
            selection.discountPercentage = $element.attr('data-regular-delivery-discount-percentage') || null;

            return selection;
        }

        function resetAddToCartRegularDeliveryModal($modal) {
            if (!$modal || !$modal.length) return;

            $modal.removeAttr('data-pli-uuid');

            var $checkbox = $modal.find('#js-hasRegularDelivery');
            if ($checkbox.length) {
                $checkbox.prop('checked', false).prop('disabled', false);
            }

            $modal.find('.cc-addProdModal__checkbox').removeClass('d-none');
        }

        function updateAddToCartRegularDeliveryCheckboxVisibility($modal, shouldShow) {
            if (!$modal || !$modal.length) return;

            var $wrapper = $modal.find('.cc-addProdModal__checkbox');
            if (!$wrapper.length) return;

            var $checkbox = $wrapper.find('#js-hasRegularDelivery');
            if (!shouldShow) {
                $checkbox.prop('checked', false);
            }

            $wrapper.toggleClass('d-none', !shouldShow);
        }

        function showRegularDeliveryModalError(message) {
            var $errorToast = $('.js-errorToast');

            if (!$errorToast.length) {
                return;
            }

            if (message) {
                $errorToast.find('.cc-toast__text').text(message);
            }

            $errorToast.removeClass('d-none').addClass('show');

            var headerHeight = $('.cc-header').height() || 0;
            var scrollAnimateOffset = $errorToast.offset().top - headerHeight - 30;

            $('html, body').animate({ scrollTop: scrollAnimateOffset }, 500);

            setTimeout(function () {
                $errorToast.removeClass('show').addClass('d-none');
            }, 3000);
        }

        function handleRegularDeliveryConvertError($checkbox, $modal) {
            $.spinner().stop();

            if ($checkbox && $checkbox.length) {
                $checkbox.prop('checked', false).prop('disabled', false);
            }

            if ($modal && $modal.length) {
                $modal.modal('hide');
            }

            showRegularDeliveryModalError();
        }

        $body.on('click', '[data-attr]', function (e) {
            var $this = $(this);
            if ($this.attr('disabled') || !$this.data('url')) return;
            var $rdContainer = findRDContainer($this);
            var url = appendRDParam($this.data('url'), $rdContainer);
            $this.data('url', url);
        });

        $body.on('change', '.options-select', function () {
            var $this = $(this);
            if ($this.closest('.js-regularDelivery').length) return;
            var originalUrl = $this.val();
            if (!originalUrl) return;
            var $rdContainer = findRDContainer($this);
            var url = appendRDParam(originalUrl, $rdContainer);
            if (url !== originalUrl) {
                $this.data('original-url', originalUrl);
                $this.val(url);
            }
        });

        $body.on('change', '.js-purchaseType', function () {
            var selectedValueId = $(this).data('value-id');
            var $container = $(this).closest('.js-regularDelivery');
            var $hiddenSelect = $container.find('.options-select');
            var defaultValueId = $container.data('default-value-id');
            var isRD = selectedValueId !== defaultValueId;

            $container.find('.js-rdFrequencyWrapper').toggleClass('d-none', !isRD);

            if (isRD && $.fn.selectpicker) {
                var $frequencySelect = $container.find('.js-rdFrequency');
                if ($frequencySelect.length) {
                    if ($frequencySelect.siblings('.dropdown-toggle').length) {
                        $frequencySelect.selectpicker('refresh');
                    } else {
                        $frequencySelect.selectpicker();
                    }
                }
            }

            var $optionContainer = $(this).closest('.cc-pdp__regularDelivery__option');
            $container.find('.cc-pdp__regularDelivery__option').removeClass('active');
            $optionContainer.addClass('active');

            var $targetOption = $hiddenSelect.find('option[data-value-id="' + selectedValueId + '"]');
            if ($targetOption.length) {
                var currentValue = $hiddenSelect.val();
                var newValue = $targetOption.val();

                if (currentValue !== newValue) {
                    $hiddenSelect.val(newValue);
                    var url = appendRDParam(newValue, $container);
                    var $productContainer = $container.closest('.set-item');
                    if (!$productContainer.length) {
                        $productContainer = $container.closest('.js-productDetail');
                    }
                    if (!$productContainer.length) {
                        $productContainer = $container.closest('.js-prod-tile');
                    }
                    if (!$productContainer.length) {
                        $productContainer = $container.closest('.product');
                    }

                    if ($productContainer.length) {
                        base.attributeSelect(url, $productContainer);
                    }
                }
            }
        });

        $body.on('updateAddToCartFormData', 'button.js-addToCart, button.add-to-cart-global, button.js-tile-quick-add-btn, button.quick-add-to-cart-global', function (e, form) {
            var selection = getRegularDeliverySelectionData($(this));

            form.isRegularDelivery = 'false';
            lastAddedAsRegularDelivery = false;
            lastAddedHasRegularDeliveryOption = !!selection.hasRegularDeliveryOption;
            lastAddedRegularDeliveryDiscountPercentage = selection.discountPercentage;
            lastAddedRegularDeliveryFrequency = selection.frequency;

            if (selection.isRegularDelivery) {
                form.isRegularDelivery = 'true';
                if (selection.frequency) {
                    form.regularDeliveryFrequency = selection.frequency;
                }
                lastAddedAsRegularDelivery = true;
            }
        });

        $body.on('product:afterAddToCart', function (e, data) {
            var $modal = $('#addToCartProductModal');

            if (!$modal.length) {
                return;
            }

            resetAddToCartRegularDeliveryModal($modal);

            var shouldShowCheckbox = lastAddedHasRegularDeliveryOption && !lastAddedAsRegularDelivery;
            updateAddToCartRegularDeliveryCheckboxVisibility($modal, shouldShowCheckbox);

            if (lastAddedRegularDeliveryFrequency) {
                $modal.find('#js-hasRegularDelivery')
                    .attr('data-regular-delivery-frequency', lastAddedRegularDeliveryFrequency)
                    .attr('data-first-frequency', lastAddedRegularDeliveryFrequency);
            }

            // Update the label text if discount percentage is available
            if (shouldShowCheckbox && lastAddedRegularDeliveryDiscountPercentage) {
                var $label = $modal.find('label[for="js-hasRegularDelivery"]');
                if ($label.length) {
                    var messageTemplate = $modal.attr('data-rd-message-template');
                    if (messageTemplate) {
                        // Replace {0} placeholder with discount percentage
                        var formattedMessage = messageTemplate.replace('{0}', lastAddedRegularDeliveryDiscountPercentage);
                        $label.html(formattedMessage);
                    }
                }
            }

            if (data && data.pliUUID) {
                $modal.attr('data-pli-uuid', data.pliUUID);
            }

            if (data && data.requestedQuantity) {
                $modal.attr('data-pli-quantity', data.requestedQuantity);
            }
        });

        $body.on('hidden.bs.modal', '#addToCartProductModal', function () {
            resetAddToCartRegularDeliveryModal($(this));
        });

        $body.on('change', '#js-hasRegularDelivery', function () {
            var $checkbox = $(this);
            var $modal = $checkbox.closest('#addToCartProductModal');
            var convertUrl = $modal.attr('data-convert-to-rd-url');
            var lineItemUUID = $modal.attr('data-pli-uuid');
            var quantity = $modal.attr('data-pli-quantity');
            var frequency = $checkbox.attr('data-regular-delivery-frequency') || $checkbox.attr('data-first-frequency');

            if (!$checkbox.is(':checked')) {
                return;
            }

            if (!convertUrl || !lineItemUUID || !frequency) {
                handleRegularDeliveryConvertError($checkbox, $modal, '', false);
                return;
            }

            $.spinner().start();

            $.ajax({
                url: convertUrl,
                method: 'POST',
                data: {
                    uuid: lineItemUUID,
                    quantity: quantity,
                    regularDeliveryFrequency: frequency
                },
                success: function (response) {
                    if (response && response.success && response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                        return;
                    }

                    handleRegularDeliveryConvertError($checkbox, $modal);
                },
                error: function () {
                    handleRegularDeliveryConvertError($checkbox, $modal);
                }
            });
        });
    }
};
